/**
 * Supported languages for translation with ISO 3166-1 alpha-2 country codes
 * Uses SVG flags from country-flag-icons for cross-platform compatibility
 */
export const SUPPORTED_LANGUAGES = [
  { code: "English", label: "English", flagCode: "GB" },
  { code: "French", label: "French", flagCode: "FR" },
  { code: "German", label: "German", flagCode: "DE" },
  { code: "Italian", label: "Italian", flagCode: "IT" },
  { code: "Spanish", label: "Spanish", flagCode: "ES" },
  { code: "Portuguese", label: "Portuguese", flagCode: "PT" },
  { code: "Arabic", label: "Arabic", flagCode: "SA" },
] as const;

export const getFlagCodeFromLanguage = (languageCode?: string) => {
  if (!languageCode) return "";
  const language = SUPPORTED_LANGUAGES.find(
    (lang) => lang.code === languageCode,
  );
  return language ? language.flagCode : "";
};
